// Node
import i18next from 'i18next';
import { any, filter, include, sortBy } from 'underscore';
import { IS_MIRTURBAZ, IS_SANATORIUMS } from './filter_main.js.jsx';
import { compareTariffs } from '../filter_utils';
import { getDisplayedFoodAndTariff } from './filter_card_tariff.js';

export default class ApartmentList extends React.Component {
  constructor(props) {
    super(props);
    this.displayApartment = null;
    this.seo_path_with_params = this.seo_path_with_params.bind(this);
    this.pluralizeCount = this.pluralizeCount.bind(this);
    this.extraApartments = this.extraApartments.bind(this);
    this.filteredApartments = this.filteredApartments.bind(this);
    this.sortApartments = this.sortApartments.bind(this);
    this.updateFoodAndPrice = this.updateFoodAndPrice.bind(this);
    this.apartmentBlock = this.apartmentBlock.bind(this);
    this.complexPlacementBlock = this.complexPlacementBlock.bind(this);
    this.renderComplexPlacementSource = this.renderComplexPlacementSource.bind(this);
  }

  seo_path_with_params() {
    let seo_path_with_params = this.props.seo_path;
    if (this.props.filter_params.url_str) seo_path_with_params += `?${this.props.filter_params.url_str}`;
    return seo_path_with_params;
  }

  // Компонент сортирует апартаменты по минимальной цене (единожды после загрузки страницы)
  // и фильтрует по типу питания
  // Поэтому обновлять компонент имеет смысл только после изменения типа питания
  pluralizeCount(num) {
    switch (num) {
      case 1:
        return 'вариант';
      case 2:
      case 3:
      case 4:
        return 'варианта';
      default:
        return 'вариантов';
    }
  }

  // Фильтрует апартаменты по питанию
  // @param [Array] apartments список апартаментов
  // @return [Array] список отфильтрованных по питанию апартаментов
  filteredApartments(apartments) {
    let result = apartments;
    if (this.props.filters.foodTypes?.length > 0) {
      result = filter(result, (apartment) => {
        return any(apartment.tariffs, (tariff) => {
          return include(this.props.filters.foodTypes, tariff.food_type);
        });
      });
    }

    if (this.props.filters.instant?.length > 0) {
      result = filter(result, (apartment) => {
        return any(apartment.tariffs, (tariff) => tariff.instant_booking);
      });
    }

    return result;
  }

  sortApartments() {
    const { apartments } = this.props;
    return sortBy(apartments, (apartment) => apartment.calculated_price);
  }

  updateFoodAndPrice() {
    const {
      apartments,
      count_guests,
      filters: { foodTypes },
      currency_name,
      delta_days,
      display_calculated_price,
    } = this.props;
    const prices = this.props.filters?.prices;
    const suitablePrice = this.props.data?.complex_placement?.suitable_price

    if (this.props.data?.complex_placement && (!prices?.length || (prices &&
      suitablePrice >= prices[0] &&
      suitablePrice <= prices[prices.length - 1]))) {
      const complex_placement = this.props.data.complex_placement;
      const priceString = `${complex_placement.suitable_price.toLocaleString('ru-RU')} ${currency_name}`;
      const priceStringWithoutDiscount = `${complex_placement.suitable_price_without_discount.toLocaleString('ru-RU')} ${currency_name}`;
      const discount = complex_placement.discount;
      const bonuses = complex_placement.total_bonuses;
      const main_tariff = this.props.data.complex_placement.items[0].tariff;
      let foodString = null;
      let conditions_name = null;
      if (delta_days && count_guests) {
        const displayedTariff = getDisplayedFoodAndTariff({
          selectedTariff: main_tariff,
          tariffCondition: main_tariff?.tariff_condition_name ?? complex_placement.conditions_name,
          delta_days,
          count_guests,
          tariffSource: main_tariff?.tariff_source,
        });
        foodString = displayedTariff.foodName;
        conditions_name = displayedTariff.tariffName || complex_placement.conditions_name || null;
      } else if (foodTypes && foodTypes.length > 0) {
        foodString =
          complex_placement.food_name_for_food_filter ||
          (foodTypes.indexOf(0) === -1 ? 'Питание включено' : 'Без питания');
        conditions_name = complex_placement.conditions_name;
      }
      const seats = complex_placement.total_guests;
      this.props.price_food_changed(
        priceString,
        foodString,
        priceStringWithoutDiscount,
        discount,
        bonuses,
        conditions_name,
        seats,
        main_tariff
      );
      return;
    }

    if (!apartments.length) return;

    let filteredApartments = this.filteredApartments(apartments);

    if (filteredApartments.length === 0) {
      filteredApartments = apartments;
    }
    const totalGuestsCount = (this.props.count_guests ?? 0) + (this.props.children_ages?.length ?? 0);

    filteredApartments.sort((a, b) => compareTariffs(a.tariffs[0], b.tariffs[0], totalGuestsCount));

    let selectedApartment = filteredApartments[0];
    let selectedTariff = selectedApartment?.tariffs?.[0];

    let apartmentPriceMin = selectedTariff.calculated_price;
    let apartmentPriceMinWithoutDiscount =
      selectedTariff.calculated_price_without_discount || selectedTariff.calculated_price;
    let minPrice = selectedTariff.calculated_price;

    // Шаг 4: Обновление отображаемых апартаментов и деталей тарифа
    if (selectedApartment) {
      this.displayApartment = selectedApartment;
      let {
        calculated_price_without_discount,
        discount,
        bonuses,
        seats,
        tariff_condition_name,
        food_name_for_food_filter,
      } = selectedTariff ?? {};
      const validSearch = delta_days && count_guests;
      calculated_price_without_discount ??= apartmentPriceMinWithoutDiscount;
      if (!minPrice || minPrice === Number.MAX_VALUE) {
        minPrice = apartmentPriceMin;
      }

      if (!minPrice && validSearch) {
        this.displayApartment = null;
        this.props.price_food_changed(null, null, null, null, null, null, null, null);
        return;
      }

      // Формирование строк с ценами
      const priceString = minPrice
        ? `${validSearch ? '' : 'от '}${minPrice.toLocaleString('ru-RU')} ${currency_name}`
        : '';
      const priceStringWithoutDiscount =
        display_calculated_price && calculated_price_without_discount
          ? `${calculated_price_without_discount?.toLocaleString('ru-RU')} ${currency_name}`
          : calculated_price_without_discount || minPrice
            ? `${(calculated_price_without_discount || minPrice)?.toLocaleString('ru-RU')} ${currency_name}`
            : '';

      // Формирование строки с информацией о питании
      let foodString = null;
      let tariffConditionName = null;
      if (validSearch) {
        const displayedTariff = getDisplayedFoodAndTariff({
          selectedTariff,
          tariffCondition: tariff_condition_name,
          delta_days,
          count_guests,
          tariffSource: selectedTariff?.tariff_source,
        });
        tariffConditionName = displayedTariff.tariffName;
        foodString = displayedTariff.foodName;
      } else if (foodTypes && foodTypes.length > 0) {
        tariffConditionName = tariff_condition_name;
        foodString = food_name_for_food_filter || (foodTypes.indexOf(0) === -1 ? 'Питание включено' : 'Без питания');
      }

      // Шаг 5: Обновление информации о цене и питании
      this.props.price_food_changed(
        priceString,
        foodString,
        priceStringWithoutDiscount,
        discount,
        bonuses,
        tariffConditionName,
        seats,
        selectedTariff
      );
    } else {
      // Сброс значений, если подходящих апартаментов нет
      this.displayApartment = null;
      this.props.price_food_changed(null, null, null, null, null, null, null, null);
    }
  }

  componentDidMount() {
    this.updateFoodAndPrice();
  }

  componentDidUpdate() {
    this.updateFoodAndPrice();
  }

  apartmentBlock(apartment) {
    const tariff = apartment.tariffs[0];
    const is_sanatoriums = IS_SANATORIUMS || window.isMobileDevice;
    const { count_guests, delta_days } = this.props;
    const validSearch = delta_days && count_guests;

    let seats = tariff?.seats + tariff?.seats_additional + tariff?.child_count_no_seats;
    if (!validSearch && apartment.price_min_seats) {
      seats = apartment.price_min_seats;
    }

    return (
      <li
        className={`card__desc-info-list-item ${is_sanatoriums && 'card__desc-info-list-sanatoriums_item'}`}
        key={apartment.id}
      >
        <div className={`card__desc-info-list-ico icon icon-users_gray icon-users_gray-dims`}></div>
        <span className='card__desc-info-list-item_seats'>×{seats}</span>
        <div className={`card__desc-info-list-item_name ${is_sanatoriums && 'card__desc-width'}`}>
          <span>{apartment.name}</span>
        </div>
      </li>
    );
  }

  renderComplexPlacementSource(source) {
    if (!source?.source_name) return null;

    return (
      <span
        className={`card__${source.source_name}`}
        title={source.text}
        style={{ marginLeft: 6 }}
      />
    );
  };

  complexPlacementBlock(complex_placement) {
    const {
      props: { count_guests, children_ages, tariffCondition, food_type_name },
    } = this;
    const is_sanatoriums = IS_SANATORIUMS || window.isMobileDevice;
    const all_guest_count =
      complex_placement.total_guests > count_guests + children_ages.length
        ? count_guests + children_ages.length
        : complex_placement.total_guests;
    const hasTariffDetails = tariffCondition || food_type_name;

    return (
      <>
        <li className={`card__desc-info-list-item ${is_sanatoriums && 'card__desc-info-list-sanatoriums_item'}`}>
          <div className={`card__desc-info-list-item_name ${is_sanatoriums && 'card__desc-width'}`} style={{ marginLeft: 0 }}>
            <span style={{ display: 'inline-flex'}}>
              {complex_placement.apartments_categories_count} {i18next.t('for_guest', { count: all_guest_count })} {this.renderComplexPlacementSource(complex_placement.source)}
            </span>
          </div>
        </li>
        {hasTariffDetails ? (
          <li className={`card__desc-info-list-item ${is_sanatoriums && 'card__desc-info-list-sanatoriums_item'}`}>
            <div className={`card__desc-info-list-item_tariff_food card__desc-width`}>
              {tariffCondition ? <span className='card__desc-info-list-item_tariff'>{tariffCondition}</span> : null}
              {food_type_name ? <span className='card__desc-info-list-item_food'>{food_type_name}</span> : null}
            </div>
          </li>
        ) : null}
      </>
    );
  }

  extraApartments() {
    let extraApartmentsCount = this.props.apartments.length - 1;
    if (extraApartmentsCount > 0) {
      return (
        <li className='card__desc-info-list-item'>
          <a
            href={`${this.seo_path_with_params()}#apartments`}
            target='_blank'
            className='camp_link link text_f14 under under_line before-ico before-ico_arrow before-ico_arrow_green'
            rel={this.props.is_nofollow ? 'nofollow' : null}
          >
            +{`${extraApartmentsCount} ${this.pluralizeCount(extraApartmentsCount)}`} размещения
          </a>
        </li>
      );
    }
  }

  render() {
    const { showAllCamps, campsLoaded, movedTariffToApartmentList, renderTariff } = this.props;

    if ((this.props.count === undefined && !showAllCamps) || (showAllCamps && !campsLoaded)) {
      return (
        <div className='card__desc-bot-info'>
          <div className='preload__line preload__line_w80pr card-loader card-loader--tabs'></div>
          <div className='preload__line preload__line_w80pr card-loader card-loader--tabs'></div>
          <div className='preload__line preload__line_w80pr card-loader card-loader--tabs'></div>
        </div>
      );
    } else if (this.displayApartment) {
      return (
        <div>
          {this.apartmentBlock(this.displayApartment)}
          {movedTariffToApartmentList && renderTariff?.()}
          {IS_MIRTURBAZ && !window.isMobileDevice && this.extraApartments()}
        </div>
      );
    } else if (this.props.data?.complex_placement) {
      return this.complexPlacementBlock(this.props.data.complex_placement);
    } else {
      return null;
    }
  }
}
